<template>
  <div class="main">
    <back />
    <div>
      <div class="cityInfo flex whiteBg" v-if="expList.length > 0">
        <div>{{ senderCity || '未填写' }}</div>
        <img src="@/../static/icon-arrow-success.svg" alt="" />
        <div>{{ addresseeCity || '未填写' }}</div>
      </div>
      <van-pull-refresh
        v-model="isRefresh"
        :head-height="80"
        @refresh="getList"
      >
        <div
          class="content"
          :style="{ height: height }"
          v-if="expList.length > 0"
        >
          <div
            class="listBox whiteBg flex"
            v-for="(item, index) in expList"
            :key="index"
            :class="currentChoose === index ? 'current' : ''"
            :style="index === expList.length - 1 ? 'margin-bottom:60px' : ''"
            @click="handleChoose(index)"
          >
            <div
              class="box-left flex"
              :style="currentChoose !== index ? 'border-color: #ccc' : ''"
            >
              <img
                src="@/../static/icon-hook-red.svg"
                alt=""
                v-show="currentChoose === index"
              />
            </div>
            <img :src="item.logoUrl" alt="" class="expIcon" />
            <div class="box-right">
              <div>{{ item.companyName }}</div>
              <div class="fee">
                <span>
                  <span>{{
                    `首重￥${item.firstPrice}/${item.firstWeight}公斤`
                  }}</span>
                  <span class="shu">丨</span>
                </span>
                <span>
                  <span>{{ `￥${item.addPrice}/${item.addWeight}公斤` }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex" style="height:100vh;" v-if="expList.length === 0">
          <van-empty description="驿站老板暂未添加快递品牌哦~" />
        </div>
      </van-pull-refresh>
      <div
        class="footer flex"
        @click="handleComfirm()"
        v-if="expList.length > 0"
      >
        <div class="placeOrder flex">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import Back from '@/components/back'
export default {
  components: {
    Back
  },
  data() {
    return {
      senderCity: '',
      addresseeCity: '',
      currentChoose: 0,
      expList: [],
      isRefresh: false,
      height: 0
    }
  },
  created() {
    this.getList()
    this.height = document.documentElement.clientHeight - 100 + 'px'
    if (this.$store.state.senderInfo) {
      this.senderCity = this.$store.state.senderInfo.city
    }
    if (this.$store.state.addresseeInfo) {
      this.addresseeCity = this.$store.state.addresseeInfo.city
    }
  },
  mounted() {},
  methods: {
    getList() {
      let params = this.$route.query
      this.$api
        .getExpressList(params)
        .then(res => {
          // console.log(res)
          this.isRefresh = false
          if (res.code === 0) {
            this.expList = res.data
            if (this.$store.state.selectedExpress) {
              let id = this.$store.state.selectedExpress.expressCompanyId
              for (let i in this.expList) {
                if (this.expList[i].expressCompanyId === id) {
                  this.currentChoose = Number(i)
                  break
                }
              }
            }
          }
        })
        .catch(() => {
          this.isRefresh = false
        })
    },
    handleChoose(index) {
      this.currentChoose = index
    },
    handleComfirm() {
      console.log(this.expList[this.currentChoose])
      this.$store.commit(
        'set_selectedExpress',
        this.expList[this.currentChoose]
      )
      this.$router.go(-1)
      // window.history.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  font-size: 14px;
}
.cityInfo {
  width: 100%;
  height: 40px;
  img {
    margin: 0 30px;
  }
}
.content {
  padding: 0 10px;
  .listBox {
    box-sizing: border-box;
    margin-top: 10px;
    padding: 15px;
    border: 1px solid transparent;
    .box-left {
      width: 26px;
      height: 26px;
      border: 1px solid #a30015;
      border-radius: 50%;
    }
    .expIcon {
      width: 50px;
      height: 50px;
      margin: 0 5vw 0 5vw;
    }
    .box-right {
      flex: 1;
      .fee {
        margin: 10px 5px 0 0;
        // border-right: 1px solid #ccc;
        .shu {
          color: #ccc;
        }
      }
    }
  }
  .current {
    border: 1px solid #a30015;
  }
  .explain {
    margin: 15px;
  }
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 54px;
  .placeOrder {
    width: calc(100% - 20px);
    height: 44px;
    border-radius: 22px;
    color: #fff;
    background-color: #a30014;
  }
}
.van-pull-refresh {
  height: calc(100vh - 100px) !important;
  overflow: auto !important;
}
</style>
